export const PUT_USER_PASSWORD_BUILDER_SUCCESS =
  "PUT_USER_PASSWORD_BUILDER_SUCCESS";
export const PUT_USER_PASSWORD_LOGBUILD_SUCCESS =
  "PUT_USER_PASSWORD_LOGBUILD_SUCCESS";

export const FETCH_USER_PROFILE_SUCCESS = "FETCH_USER_PROFILE_SUCCESS";
export const PUT_USER_PROFILE_SUCCESS = "PUT_USER_PROFILE_SUCCESS";
export const PUT_USER_PROFILE_START = "PUT_USER_PROFILE_START";
export const PUT_USER_PASSWORD_START = "PUT_USER_PASSWORD_START";
